import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class Companies extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companies: props.companiesAll || [],
      isLoading: true,
      url: props.url || "/api/v1/portal/companies",
    };

    this.getCompanies();
  }

  getCompanies() {
    let url = this.state.url;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((companiesJson) => {
        this.setState({
          companies: companiesJson,
          isLoading: false
        });
      });
    });
  }

  render() {
    let Companies = [];
    this.state.companies.forEach(function(i) {
      Companies.push(<Company key={'company-'+i.id} data={i} />);
    });

    return (
      <div>
        {this.state.isLoading ?
          <span className="add-loading-text">
            <i className="fa fa-spinner fa-pulse"></i>
          </span> : Companies}
      </div>
    );
  }
}

class Company extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return(
      <div className="company">
        <h2>
          <a href="#">
            GEMINI
          </a>&nbsp;
          <a href={"/jobs/company/"+this.props.data.id}
             className="btn btn-primary">
            View Jobs
          </a>
        </h2>
        <h4>
          {this.props.data.name}
        </h4>
        <hr />
      </div>
    );
  }
}


if (document.getElementById('react-component-g4-logistics-portal-companies')) {
  ReactDOM.render(<Companies />, document.getElementById('react-component-g4-logistics-portal-companies'));
}
